import React from 'react'

export default function  footer
() {
  return (
    <footer className='items-center'>
        <h1 id="pull-center">Rocket Monsters</h1>
        <p className='justify-between item-center mt-4 mb-4 text-black text-lg ' id="pull-center">Rocket Monsters NFTs are all playable characters in our Unreal Engine 5 game.</p>
        <div className='flex  items-center justify-center gap-2'> 
                 <div>   
                 <a href='https://twitter.com/MonstersRocket'><img
      alt="Rock Monsitor"
      src="/twitter.png"
      
      width={30}
      height={30}
    />
    </a></div>
         
         <div>
         <a href='https://discord.gg/xpzHexbhyU'><img
      alt="Rock Monsitor"
      src="/discord.png"
      width={30}
      height={30}
    />
    </a>
         </div>
  <div> 
     <a href='https://www.youtube.com/c/RocketMonsters/videos'><img
      alt="Rock Monsitor"
      src="/youtube.png"
      width={30}
      height={30}
      
    />
    </a>
    </div>
    </div>
    
    </footer>
    
  )
}
